import sortBy from 'lodash/sortBy';

import {ApiResource} from 'common/util/model-resource/api-resource';
import {
  annotationTagsClient,
  createAnnotationTag,
  CreateAnnotationTagParams,
} from 'common/report/queries/app-api/annotation-tag-client';
import {AnnotationTag} from 'common/report/model-resources/annotation-tags/types';

const CREATE_KEY = `create`;

export class AnnotationTagsResource extends ApiResource<AnnotationTag> {
  apiClient = annotationTagsClient;

  private async upsertWrapper(loadingKey: string, requestFn: () => Promise<AnnotationTag>) {
    // @ts-ignore
    this.fetchesInProgress.set(loadingKey, undefined);
    this.notifySubscribers();
    try {
      const annotationTag = await requestFn();

      this.update({[annotationTag.id]: annotationTag}, {partialUpdate: true});

      return annotationTag;
    } finally {
      this.fetchesInProgress.delete(loadingKey);
      this.notifySubscribers();
    }
  }

  getSortedTags(): AnnotationTag[] {
    return sortBy(
      this.getAllValues().filter((tag) => tag.has_annotations),
      (tag) => tag.name,
    );
  }

  getFilterTags(tagIdSet: Set<number>): AnnotationTag[] {
    return sortBy(
      this.getAllValues().filter((tag) => tag.has_annotations || tagIdSet.has(tag.id)),
      (tag) => tag.name,
    );
  }

  getTag({name, id}: {name?: string; id?: number}): AnnotationTag | undefined {
    return this.getAllValues()?.find((tag) => {
      return (!name || tag.name === name) && (!id || tag.id === id);
    });
  }

  createAnnotationTag(params: CreateAnnotationTagParams): Promise<AnnotationTag> {
    return this.upsertWrapper(CREATE_KEY, () => createAnnotationTag(params));
  }
}
